import React from "react";
import { PublicEnquiryModel } from "../../../domain/PublicEnquiry";
import { AddNoteDialog } from "./dialogs/AddNoteDialog";
import { InternalMessageDialog } from "./dialogs/InternalMessageDialog";
import { DialogType, EntityDialog } from "./types";

type RenderDialogProps = {
  focussedEntity: EntityDialog | null;
  onClose: () => void;
  publicEnquiry: PublicEnquiryModel;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  publicEnquiry,
}) => {
  if (!focussedEntity) return null;

  const { dialogType } = focussedEntity;
  //console.log(dialogType)

  if (dialogType === DialogType.AddNote) {
    return <AddNoteDialog onClose={onClose} resource={publicEnquiry} />;
  } else if(dialogType === DialogType.AddInternalMessage){
    return <InternalMessageDialog onClose={onClose} resource={publicEnquiry} />;
  } 
  else {
    // other activity dialog renderers....
    return null;
  }
};
